export const POST_COMP_MANUFACTURE = "POST_COMP_MANUFACTURE"
export const POST_COMP_MANUFACTURE_SUCCESS = "POST_COMP_MANUFACTURE_SUCCESS"
export const POST_COMP_MANUFACTURE_FAIL = "POST_COMP_MANUFACTURE_FAIL"